/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoSlackIcon16Light } from './LogoSlackIcon16Light';
import { LogoSlackIcon16Regular } from './LogoSlackIcon16Regular';
import { LogoSlackIcon16Solid } from './LogoSlackIcon16Solid';
import { LogoSlackIcon20Light } from './LogoSlackIcon20Light';
import { LogoSlackIcon20Regular } from './LogoSlackIcon20Regular';
import { LogoSlackIcon20Solid } from './LogoSlackIcon20Solid';
import { LogoSlackIcon24Regular } from './LogoSlackIcon24Regular';
import { LogoSlackIcon24Solid } from './LogoSlackIcon24Solid';
import { LogoSlackIcon32Regular } from './LogoSlackIcon32Regular';
import { LogoSlackIcon64Regular } from './LogoSlackIcon64Regular';
var sizes = {
    16: {
        light: LogoSlackIcon16Light,
        regular: LogoSlackIcon16Regular,
        solid: LogoSlackIcon16Solid,
    },
    20: {
        light: LogoSlackIcon20Light,
        regular: LogoSlackIcon20Regular,
        solid: LogoSlackIcon20Solid,
    },
    24: {
        regular: LogoSlackIcon24Regular,
        solid: LogoSlackIcon24Solid,
    },
    32: {
        regular: LogoSlackIcon32Regular,
    },
    64: {
        regular: LogoSlackIcon64Regular,
    },
};
export var LogoSlackIcon = forwardRef('LogoSlackIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
